import default_image1 from "src/assets/images/dashaboardCards/default_project_thumbnail1.svg";
import default_image2 from "src/assets/images/dashaboardCards/default_project_thumbnail2.svg";
import default_image3 from "src/assets/images/dashaboardCards/default_project_thumbnail3.svg";

const defaultImages = [default_image1, default_image2, default_image3];

export { defaultImages };
